(() => {
  function renderRecent(modal) {
    const section = modal.querySelector('[data-kpc-search-recent]');
    const list = modal.querySelector('[data-kpc-search-recent-list]');
    if (!section || !list) return;
    list.replaceChildren();
    let products = [];
    try {
      const stored = JSON.parse(localStorage.getItem('kpc:recently-viewed-products') || '[]');
      products = Array.isArray(stored) ? stored : [];
      if (!products.length) {
        const last = JSON.parse(localStorage.getItem('kpc:last-viewed-product') || 'null');
        if (last) products = [last];
      }
    } catch (_) { products = []; }
    products.filter(p => p && typeof p.url === 'string' && p.url.startsWith('/products/')).slice(0, 4).forEach(p => {
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.className = 'kpc-search-recent__item';
      a.href = p.url;
      if (p.image && typeof p.image === 'string' && /^(https:\/\/|\/\/)/.test(p.image)) {
        const img = document.createElement('img');
        img.src = p.image;
        img.alt = p.imageAlt || p.title || '';
        img.width = 58;
        img.height = 70;
        img.loading = 'lazy';
        a.append(img);
      }
      const details = document.createElement('span');
      const title = document.createElement('strong');
      title.textContent = p.title || 'Product';
      details.append(title);
      if (p.price) {
        const price = document.createElement('small');
        price.textContent = p.price;
        details.append(price);
      }
      a.append(details);
      li.append(a);
      list.append(li);
    });
    section.hidden = !list.children.length;
  }
  function init(modal) {
    if (modal.dataset.kpcDiscoveryReady) return;
    modal.dataset.kpcDiscoveryReady = 'true';
    const input = modal.querySelector('.search__input');
    const discovery = modal.querySelector('[data-kpc-search-discovery]');
    const empty = modal.querySelector('[data-kpc-search-empty]');
    const predictive = modal.querySelector('predictive-search');
    if (!input || !discovery) return;
    function update() {
      const hasQuery = Boolean(input.value.trim());
      discovery.hidden = hasQuery;
      if (empty) empty.hidden = !hasQuery || !predictive || predictive.hasAttribute('loading') ||
        predictive.querySelector('[data-total-results]')?.dataset.totalResults !== '0';
    }
    input.addEventListener('input', update);
    input.form?.addEventListener('reset', () => requestAnimationFrame(update));
    modal.querySelector('details')?.addEventListener('toggle', event => {
      if (event.target.open) { renderRecent(modal); update(); }
    });
    if (predictive) new MutationObserver(update).observe(predictive, { attributes: true, attributeFilter: ['loading', 'results', 'open'], childList: true, subtree: true });
    renderRecent(modal);
    update();
  }
  document.querySelectorAll('details-modal.header__search').forEach(init);
})();